import './style/index.js';

import _Descriptions from './Descriptions';

export type { DescriptionsProps } from './Descriptions';

export const Descriptions = _Descriptions;

export default Descriptions;
